import __request__ from "routing/request";
export function list(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.report/widgets", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function details(JSONbody, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.report/widgets/details", JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function listPaginated(sort = "title", page = 1, per_page = 50, order = "asc", query, filters, requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.report/widgets/paginated", null, { "page": page, "per_page": per_page, "sort": sort, "order": order, "query": query, "filters": filters }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
